// extracted by mini-css-extract-plugin
module.exports = {"container":"Write_container__2Un7b","itemA":"Write_itemA__9rkVg","itemB":"Write_itemB__1wnWx","itemC":"Write_itemC__9HiP1"};